import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { CustomerMatchingClient } from "../../../../../../Wrap/Api/Customer/CustomerMatching";
import { IJsonDate } from "../../../../../../Wrap/System/IJsonDate";
import { CustomerMatchingDispatcher, CustomerMatchingStore } from "../Stores/Variable";

export class CustomerMatchingAction{

    public static getMatchingCustomers(firstName: string, lastName: string, dateofBirth: IJsonDate, ownerAdviserId: number, pageIndex: number, pageSize: number, callBack) {
        const client = new CustomerMatchingClient();
        const promise = client.get(firstName + "%", lastName + "%", dateofBirth, ownerAdviserId, pageIndex, pageSize);

        promise.onSuccess((res) => {
            let data = JSON.parse(JSON.stringify(CustomerMatchingStore.getData()));
            if (!data) {data = {};}
            data = res;
            CustomerMatchingDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: data,
            });
            console.log(data);
            if (callBack) {
                callBack(res);
            }
        });

        promise.onError((err) => {
            CustomerMatchingDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }
  }